// export function formatDate(date) {
//     if (!date) return '';

//     return new Date(date).toLocaleString('pl-PL');
// }


// export function formatDate(date) {
//     if (!date) return '';
//     return new Date(date).toLocaleString()
// }



// export function formatDate(date) {
//     if (!date) return '';

//     const d = new Date(date);

//     const parts = new Intl.DateTimeFormat('pl-PL', {
//         year: 'numeric',
//         month: '2-digit',
//         day: '2-digit',
//         hour: '2-digit',
//         minute: '2-digit',
//         second: '2-digit',
//         hour12: false
//     }).formatToParts(d);

//     const get = (type) => parts.find(p => p.type === type)?.value;

//     return `${get('year')}.${get('month')}.${get('day')} ${get('hour')}:${get('minute')}:${get('second')}`;
// }



export function formatDate(date) {
    if (!date) return '';

    const d = new Date(date);

    const pad = (n) => String(n).padStart(2, '0');

    return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}